import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import styles from './ConnectAmazonMcfForm.module.scss';

function ConnectAmazonMcfForm(props) {
  const submit = (e) => {
    props.submit();
    e.preventDefault();
  };

  return (
    <form className={styles.form} onSubmit={submit}>
      <p>This will redirect you to Amazon MCF's site to authenticate Cymbio as an integration.</p>

      <div className={styles.footer}>
        <div className={styles.button}>
          <Button type="submit" text="OK" />
        </div>
      </div>
    </form>
  );
}

export default ConnectAmazonMcfForm;

ConnectAmazonMcfForm.propTypes = {
  submit: PropTypes.func.isRequired,
};
